import {getConfig} from '@salesforce/pwa-kit-runtime/utils/ssr-config'

/**
 * Constructs a redirectURI by combining `appOrigin` with `redirectPath`.
 * Ensures that `redirectPath` starts with a '/'.
 * Returns an empty string if `redirectPath` is falsy.
 *
 * @param {*} appOrigin
 * @param {*} redirectPath - relative redirect path
 * @returns redirectURI to be passed into the social login flow
 */
export const buildRedirectURI = (appOrigin = '', redirectPath = '', site = '', locale = '') => {
    const instance = getConfig()?.app?.library?.instanceName
    if (redirectPath) {
        redirectPath =
            instance === 'LOCAL' ? site?.id + '/' + locale?.id + redirectPath : redirectPath
        const path = redirectPath.startsWith('/') ? redirectPath : `/${redirectPath}`
        return `${appOrigin}${path}`
    } else {
        return ''
    }
}

export * from '@salesforce/retail-react-app/app/utils/utils'
